__turbopack_context__.v({
  "acceptButton": "CookieBanner-module__pb-mRa__acceptButton",
  "acceptButtonContent": "CookieBanner-module__pb-mRa__acceptButtonContent",
  "cookieActionButtonsContainer": "CookieBanner-module__pb-mRa__cookieActionButtonsContainer",
  "cookieBannerButtonRow": "CookieBanner-module__pb-mRa__cookieBannerButtonRow",
  "cookieBannerContainer": "CookieBanner-module__pb-mRa__cookieBannerContainer",
  "cookieContentContainer": "CookieBanner-module__pb-mRa__cookieContentContainer",
  "informationDetailsContent": "CookieBanner-module__pb-mRa__informationDetailsContent",
  "initial": "CookieBanner-module__pb-mRa__initial",
  "logo": "CookieBanner-module__pb-mRa__logo",
  "logoWrapper": "CookieBanner-module__pb-mRa__logoWrapper",
  "moreInformationWrapper": "CookieBanner-module__pb-mRa__moreInformationWrapper",
  "open": "CookieBanner-module__pb-mRa__open",
  "row": "CookieBanner-module__pb-mRa__row",
  "simulatedLink": "CookieBanner-module__pb-mRa__simulatedLink",
  "textContent": "CookieBanner-module__pb-mRa__textContent",
});
